import { useCallbackRef } from '@synoptic/ui-kit/utils/use-callback-ref.tsx';
import { useEffect } from 'react';

export const useInterval = (callback: () => void, delay: number | null) => {
  const cb = useCallbackRef(callback);

  useEffect(() => {
    function tick() {
      cb();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [cb, delay]);
};
